// ============================================================
// CONFIGURATION - Replace these values with your actual values
// ============================================================

import { Platform } from 'react-native';

export interface Auth0Config {
  domain: string;
  clientId: string;
  audience: string;
}

export interface ApiConfig {
  baseURL: string;
  timeout: number;
}

export const AUTH0_CONFIG: Auth0Config = {
  
  domain: 'auth.jeevansanyog.com',       // prod custom domain
  
  clientId: Platform.OS === 'web'
    ? '9VCfdmEBrFlGNPlFsBWpheU2SR6Gvs3P'
    : '6jfe3EDwMApHruaE3BWuVAm0TvtDMaka',   //prod

    audience: 'https://JeevanSanyog-API',         
};

export const API_CONFIG: ApiConfig = {

  baseURL: 'https://api.jeevansanyog.com/sanjog/api/', //prod
  timeout: 15000,
};

export const ROLES = {
  ADMIN: 'admin',
  USER: 'user',
} as const;

export type Role = typeof ROLES[keyof typeof ROLES];

